import image from './recent-calls-tour.png'

export default (): React.ReactElement => <img width="340px" height="176px" src={image} alt="recent calls" />
